import {
  DocumentsDocument,
  ToggleVisibilityDocument,
  ToggleVisibilityMutation,
  ToggleVisibilityMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useToggleVisibilityDocument = () => {
  const [toggleVisibilityMutation, { loading }] = useMutation(ToggleVisibilityDocument, {
    extractorFn: (data: ToggleVisibilityMutation) =>
      data.documentsMutations.toggleVisibilityDocumentsDocument,
  })

  return {
    loading,
    toggleVisibilityDocument(variables: ToggleVisibilityMutationVariables) {
      return toggleVisibilityMutation({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: DocumentsDocument,
            variables: {
              id: variables.id,
            },
          },
        ],
      })
    },
  }
}

export default useToggleVisibilityDocument
